import { ModalV2 } from '$components/Modal-V2'
import {
  modalContainerWrapper,
  modalContentWrapper,
  modalNavButton
} from '$components/Modal-V2/index.css'
import { Icon } from '@genie-fintech/ui/icons'
import { useBoolean } from 'ahooks'
import { useCallback, useState } from 'react'
import {
  closeButtonWrapper,
  container,
  IconContainer,
  iconStyles
} from './styles.css'
import { APP_DOCS_URL } from '$services/environments'
import { getLocalStorage } from '$app/utils'
import { APP_TOKEN_KEY } from '$app/constants/common'
import { CircleHelp } from 'lucide-react'

const HelpIcon = () => {
  const [open, { setTrue: openModal, setFalse: closeModal }] = useBoolean()
  const [iframeSrc, setIframeSrc] = useState<string | null>(null)
  const token = getLocalStorage(APP_TOKEN_KEY)

  const handleClick = useCallback(() => {
    if (!token) return
    setIframeSrc(`${APP_DOCS_URL}/?token=${token}`) // Set the iframe source URL
    openModal()
  }, [openModal, token])

  if (!APP_DOCS_URL) return null
  return (
    <>
      <button type="button" className={IconContainer} onClick={handleClick}>
        <CircleHelp className={iconStyles} size={18} />
      </button>

      <ModalV2
        open={open}
        onClose={closeModal}
        contentClassName={modalContainerWrapper({ isFullScreen: true })}
        contentStyle={{
          maxWidth: '100%'
        }}
      >
        {iframeSrc && (
          <>
            <div
              className={modalContentWrapper({
                isFullScreen: true
              })}
            >
              <div className={closeButtonWrapper}>
                <button
                  type="button"
                  className={modalNavButton({ iconOnly: true })}
                  onClick={closeModal}
                  autoFocus={false}
                >
                  <Icon namespace="Cross" width="20" height="20" /> Close
                </button>
              </div>
              <iframe
                src={iframeSrc}
                className={container}
                title="Embedded Content"
              />
            </div>
          </>
        )}
      </ModalV2>
    </>
  )
}

export default HelpIcon
